import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <>
      <div className="pagehead">
        <h1>Not found</h1>
        <div className="sub">This page does not exist.</div>
      </div>
      <div className="card">
        <div className="empty">
          Return to <Link to="/documents">Documents</Link>.
        </div>
      </div>
    </>
  );
}
